import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import PaiTextField from '../../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  userName: string;
  password: string;
  loading: boolean;

  handleUserNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handlePasswordChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleEditLinkedinAccount(): void;
}

const EditLinkedinAccountLoginInformationDialog: React.FC<Props> = ({
  open,
  userName,
  password,
  loading,
  handleUserNameChange,
  handlePasswordChange,
  handleClose,
  handleEditLinkedinAccount,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'} transitionDuration={0}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('editLinkedinAccount')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.formTitle}>{`* ${t('linkedinAccountInformation')}`}</Typography>
          <Typography className={classes.clarificationText}>{t('linkedinAccountClarification')}</Typography>
          <PaiTextField
            value={userName}
            placeholder={`${t('email')} (LinkedIn)`}
            autocomplete={'off'}
            name={'linkedin-email'}
            onChange={handleUserNameChange}
          />
          <PaiTextField
            value={password}
            placeholder={`${t('password')} (LinkedIn)`}
            autocomplete={'new-password'}
            name={'linkedin-password'}
            type={'password'}
            onChange={handlePasswordChange}
          />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleEditLinkedinAccount} loading={loading} disabled={!userName || !password} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
    padding: '20px',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  formTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  clarificationText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.primary.main,
    marginBottom: '4px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EditLinkedinAccountLoginInformationDialog;
